export default __webpack_public_path__ + "static/media/PhoneLogo.3e7075a6.png";